import { render, staticRenderFns } from "./LeakageCauseLocationQuestion.vue?vue&type=template&id=3406d56a"
import script from "./LeakageCauseLocationQuestion.vue?vue&type=script&lang=ts"
export * from "./LeakageCauseLocationQuestion.vue?vue&type=script&lang=ts"
import style0 from "./LeakageCauseLocationQuestion.vue?vue&type=style&index=0&id=3406d56a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports